import { OtpService } from "../../services/OtpService";
import { extractApiError } from "../../utils/extractApiError";
import { FOLLOW_UP_RESET } from "./followUpSlice";
import { isValidOtpDestination, otpDestinationError, } from "../../types/otpChannel";
function destinationOf(state) {
    return state.otpChannel === "email"
        ? { channel: "email", email: state.patientEmail.trim() }
        : {
            channel: "phone",
            countryCode: state.countryCode,
            phoneNumber: state.patientPhone,
        };
}
export const createOtpSlice = (set, get) => ({
    otpChannel: "phone",
    otpChannels: ["phone"],
    countryCode: "+91",
    patientPhone: "",
    patientEmail: "",
    otpCode: "",
    otpSent: false,
    otpVerified: false,
    otpSending: false,
    otpVerifying: false,
    otpError: null,
    setCountryCode: (code) => set({ countryCode: code }),
    setPatientPhone: (phone) => set({ patientPhone: phone }),
    setPatientEmail: (email) => set({ patientEmail: email }),
    setOtpCode: (code) => set({ otpCode: code }),
    setOtpError: (error) => set({ otpError: error }),
    setOtpChannel: (channel) => {
        if (get().otpChannel === channel)
            return;
        set({
            otpChannel: channel,
            otpCode: "",
            otpSent: false,
            otpError: null,
        });
    },
    sendOtp: async () => {
        const state = get();
        if (!isValidOtpDestination(state.otpChannel, {
            countryCode: state.countryCode,
            phoneNumber: state.patientPhone,
            email: state.patientEmail,
        })) {
            set({ otpError: otpDestinationError(state.otpChannel) });
            return;
        }
        set({ otpSending: true, otpError: null });
        try {
            await OtpService.sendOtp(destinationOf(state));
            set({ otpSent: true, otpCode: "", currentStep: "otp" });
        }
        catch (e) {
            set({
                otpError: extractApiError(e, "Failed to send OTP. Please try again."),
            });
        }
        finally {
            set({ otpSending: false });
        }
    },
    verifyOtp: async () => {
        const state = get();
        if (!state.otpCode || state.otpCode.length !== 6) {
            set({ otpError: "Please enter a 6-digit OTP code." });
            return;
        }
        set({ otpVerifying: true, otpError: null });
        try {
            await OtpService.verifyOtp({
                ...destinationOf(state),
                otpCode: state.otpCode,
            });
            set({ otpVerified: true, currentStep: "patient-selection" });
        }
        catch (e) {
            set({
                otpError: extractApiError(e, "Invalid OTP code. Please try again."),
            });
        }
        finally {
            set({ otpVerifying: false });
        }
    },
    resetOtp: () => set({
        otpCode: "",
        otpSent: false,
        otpVerified: false,
        otpSending: false,
        otpVerifying: false,
        otpError: null,
        ...FOLLOW_UP_RESET,
    }),
});
